<template>
  <div class="page-content">
    <page-template ref="returnTemplate"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
                   :detailColumns="detailColumns"
                   @searchReset="searchReset"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';
  import userPower from '@/mixin/userPower'
  import date from '@/mixin/date'

  export default {
    mixins: [userPower, date],
    components: {
      pageTemplate
    },
    data() {
      return {
        listShow: false,
        goodList: [],
        dialogShow: false,
        dialogVisibility: false,
        // 高级搜索条件
        searchOptions: {
          simple: [
            {label: '业务单号', prop: 'orderNo', type: 'input', ifFuzzy: true, placeholder: "请输入业务单号"},
          ],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24
            },
            {
              label: "门店名称",
              type: "select",
              prop: "storeId",
              isHasAll:true,
              data: [],
              url: api.system.seStore,
              change: this.getSupplier,
            },
            {
              label: "仓库名称",
              type: "select",
              prop: "warehouseId",
              span: 8,
              data: [],
            },
            {
              label: "供应商",
              type: "select",
              prop: "supplierId",
              data: [],
              // url: api.archives.supplier
            },
            {
              label: '审核状态',
              type: 'select',
              prop: 'reviewerStatus',
              defaultValue: 20,
              span: 8,
              data: [
                {label: '未审核', value: 20},
                {label: '已审核', value: 10}
              ],
            },
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: '新增',
            code: 'insert',
            callback: this.addRequisition
          },
          // {
          //   label: '打印',
          //   code: 'print',
          // },
          {
            label: '导出',
            code: 'export',
            callback: this.goodsDetailExport
          },
          {
            label: '编辑',
            type: this.$utils.buttonType.tableOperate,
            code: 'update',
            callback: this.toEditPage,
            filter: (data) => {
              return data.reviewerStatus == 10 ? false : true;
            }
          },
          {
            label: '删除',
            code: 'delete',
            type: this.$utils.buttonType.tableOperate,
            filter: (data) => {
              return data.reviewerStatus == 10 ? false : true;
            }
          },
        ],
        // 表格信息配置
        tableOptions: {
          tableName: 'clearTable',
          showSelect: true,
          indexShow: true,//是否显示索引
          columns: [
            {
              label: '业务单号',
              prop: 'orderNo',
              width: '240',
              align: 'center',
              // showDetail: true
              callback: this.goOrderDetail
            },
            {label: '门店仓库', prop: 'warehouseName', width: '180', align: 'center'},
            {label: '供应商名称', prop: 'supplierName', width: '180', align: 'center'},
            {
              label: '审核状态',
              prop: 'reviewerStatus',
              width: '120',
              align: 'center',
              enumData: this.$utils.getCacheStatus('pcPurchaseOrder.reviewerStatus')
            },
            {label: '单据金额', prop: 'billAmt', width: '100', align: 'center'},
            {label: '制单人', prop: 'voucherName', width: '120', align: 'center'},
            {label: '制单日期', prop: 'voucherDttm', width: '150', align: 'center'},
            {label: '审核人', prop: 'reviewerName', width: '120', align: 'center'},
            {label: '审核日期', prop: 'reviewerDttm', width: '150', align: 'center'},
            {label: '备注', prop: 'remarks', width: '125', align: 'center'},
          ],
          param: {reviewerStatus: 20, stCreateDttm: this.getStMonthDate(), edCreateDttm: this.getEdMonthDate()}
          // url: api.purchase.return
        },
        detailColumns: {
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            },
            right: '100px',
            top: '30px',
          },
          span: 8,
          labelWidth: "130",
          columns: [
            {
              label: '业务单号',
              type: 'input',
              prop: 'orderNo',
              disabled: true
            },
            {
              label: '采购门店',
              prop: 'storeName',
            }, {
              label: '供应商',
              type: 'select',
              prop: 'supplierName',
            }, {
              label: '仓库名称',
              type: 'select',
              prop: 'warehouseName',
            }, {
              label: '经手人',
              prop: 'handler',
              type: 'input',
            },
            {
              label: '采购入库单',
              type: 'select',
              prop: 'storageOrderNo',
              data: [],
              labelKey: 'orderNo',
            },
            {
              label: '备注',
              type: 'input',
              prop: 'remarks',
            }],
          tablesProp: {
            goodsMapList: {
              url: api.purchase.goods + "/page",
              height:this.detailHeight,
              showSummary:true,
              indexShow: true,
              tableName: "goodsMapList",
              summaryColumns: ['goodsNum', 'giveGoodsNum','totalPrice'],
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  type: 'more',
                  callback: this.getInfo,
                  width: '180',
                  align: "center"
                },
                {
                  label: "商品名称",
                  prop: "goodsName",
                  width: '120',
                  align: "center"
                },
                {
                  label: "规格",
                  prop: "specs",
                  width: '90',
                  align: "center"
                },
                {
                  label: '单位',
                  width: '90',
                  prop: 'unitName',
                  align: "center"
                },
                {
                  label: '自编码',
                  width: '90',
                  prop: 'artNo',
                  align: "center"
                },
                // {
                //   label: '档案进价',
                //   prop: 'buyPrice',
                //   align: "center"
                // },
                {
                  label: '数量',
                  prop: 'goodsNum',
                  type: 'inputNumber',
                  align: "center",
                  change: this.numChange
                },
                {
                  label: '赠送数量',
                  prop: 'giveGoodsNum',
                  type: 'input',
                  align: "center"
                },
                {
                  label: '进价',
                  prop: 'price',
                  type: 'input',
                  align: "center",
                  change: this.priceChange
                },
                {
                  label: '小计金额',
                  prop: 'totalPrice',
                  type: 'input',
                  align: "center"
                },
                {
                  label: '零售价',
                  prop: 'retailPrice',
                  align: "center"
                },
                {
                  label: '零售金额',
                  prop: 'salesAmount',
                  align: "center"
                },
                {
                  label: '系统库存',
                  width: '90',
                  prop: 'inventoryNum',
                  align: "center"
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '150',
                  align: "center"
                },
              ],
            }
          },
          // 打印的列表
          printTablesProp: {
            goodsMapList: {
              tableName: 'goodsMapList',
              showSummary: true,
              summaryColumns: ['retailPrice', 'salesAmount', 'buyPrice', 'goodsNum'],
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  type: 'more',
                  callback: this.getInfo,
                  width: '180',
                  align: "center"
                },
                {
                  label: "商品名称",
                  prop: "goodsName",
                  width: '120',
                  align: "center"
                },
                {
                  label: "规格",
                  prop: "specs",
                  width: '90',
                  align: "center"
                },
                {
                  label: '自编码',
                  width: '90',
                  prop: 'artNo',
                  align: "center"
                },
                {
                  label: '零售价',
                  width: '100',
                  prop: 'retailPrice',
                  align: "center"
                },
                {
                  label: '零售金额',
                  prop: 'salesAmount',
                  align: "center"
                },
                {
                  label: '进价',
                  prop: 'buyPrice',
                  align: "center"
                },
                {
                  label: '退货数量',
                  prop: 'goodsNum',
                  type: 'inputNumber',
                  align: "center",
                  change: this.numChange
                },
              ],
            },
          },
          url: api.purchase.return
        }
      };
    },
    beforeCreate() {
      this.detailHeight = document.documentElement.clientHeight - 180 - 200
    },
    created() {
      this.setStore(this.searchOptions.complex);
      let userInfo = this.$utils.getSysUser();
      if (userInfo.storeId) {
        this.getSupplier(userInfo)
      }
    },
    mounted() {
      if(Object.keys(this.$route.params).length>0){
        if(this.$route.params.customQuery){
          let str = this.$route.params.customQuery
          this.tableOptions.param = eval('(' + str + ')')
        }
      }
      this.$nextTick(()=>{
        this.tableOptions.url = api.purchase.return
        this.$refs['returnTemplate'].operationSuccess();
      })
    },
    methods: {
      // 搜索重置
      searchReset(){
        let userInfo = this.$utils.getSysUser();
        if (!userInfo.storeId) {
          this.searchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = []
        }
      },
      getSupplier(param) {
        param.supplierId = '';
        param.warehouseId = '';
        let supplierId = this.searchOptions.complex.filter(item => item.prop === 'supplierId')[0];
        this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {storeId: param.storeId, type: 10}).then(data => {
          if (data.code === 200) {
            supplierId.data = data.data;
          }
        });
        let warehouseId = this.searchOptions.complex.filter(item => item.prop === 'warehouseId')[0];
        this.$axios.fetchPost(api.warehouse.warehouse + '/query/warehouse/list', {
          storeId: param.storeId
        }).then(data => {
          if (data.code === 200) {
            warehouseId.data = data.data;
          }
        });
      },
      goOrderDetail(row) {
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.detailColumns);
        this.$router.push({
          path: '/purchase/return/detail?id=' + row.id,
          query: {redirect: '/purchase/return'}
        }).catch(err => {
        });
      },
      addRequisition() {
        this.$router.push({path: '/purchase/return/add'});
      },
      toEditPage(row) {
        this.$router.push({path: '/purchase/return/add?id=' + row.id});
      },
      goodsDetailExport() {
        let selectData = this.$refs["returnTemplate"].$refs["tableTemp"].selectRow;
        if (selectData.length === 0) {
          this.$confirm('请选择一条数据！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
        } else {
          if (selectData.length > 1) {
            this.$confirm('只能选择一条数据！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$refs["returnTemplate"].$refs["tableTemp"].$refs["clearTable"].clearSelection();
            })
          } else {
            console.log(selectData[0].orderNo);
            this.$axios.fetchPost(api.purchase.returnExport, {
              orderNo: selectData[0].orderNo,
              exportCode: 'PcPurchaseReturnExport'
            }).then(data => {
              if (data.code === 200) {
                const elink = document.createElement('a');
                elink.href = data.data;
                elink.click();
                this.loadingExt = false;
                this.$notify({
                  type: "success",
                  title: '导出操作',
                  message: '成功',
                  showClose: false,
                });
                // this.$message({message: '导出成功', type: 'success'});
              } else {
                this.$notify({
                  type: "error",
                  title: '导出操作',
                  message: '失败',
                  showClose: false,
                });
                // this.$message({message: '导出异常', type: 'error'});
              }
            })
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/purchase/Return.vue